<template>
    <div v-if="isreadshow" v-loading="loading" element-loading-text="导出中，请稍后">
        <my-search @search="searchHandler" v-model="pgData">
            <el-form-item slot="time">
                <el-input type="text" v-model="pgData.bdname" placeholder="请输入标段名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <my-select :data="shlist" :props="{label:'name',value:'type'}" v-model="pgData.shbj" ></my-select>
            </el-form-item>
            <el-form-item>
                <el-input type="text" v-model="pgData.tbdwname" placeholder="请输入投标人名称" clearable></el-input>
            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-download" @click="exportexcel()">导出excel</el-button>
                <el-tooltip class="item" effect="light" content="支持检索导出" placement="top-end">
                    <el-button type="success" icon="el-icon-download" @click="downloadBmzl()">一键导出报名资料</el-button>
                </el-tooltip> 
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <!-- <el-table-column label="编号" prop="guidcode" min-width="220" fixed></el-table-column> -->
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="投标人名称" prop="tbdwname"></el-table-column>
            <el-table-column label="联系方式" prop="tblxr" min-width="120">
                <template slot-scope="scope">
                    <p>
                        姓名：{{scope.row.tblxr}} 
                    </p>
                    <p>
                        手机：{{scope.row.mobile}} 
                    </p>
                    <p>
                        邮箱：{{scope.row.email}} 
                    </p>
                </template>
            </el-table-column>
            <el-table-column label="提交报名资料时间" prop="addtime"></el-table-column>
            <el-table-column label="状态" prop="shbj">
                <template slot-scope="scope">
                    <my-tag type="primary" v-if="scope.row.shbj==='1'">已提交待审核</my-tag>
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">未提交</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">已通过</my-tag>
                    <my-tag type="danger"  v-if="scope.row.shbj==='3'">
                        <div>
                            退回原因:
                            <div>
                                {{scope.row.auditcontent}}
                            </div>
                        </div>
                       </my-tag>
                </template>
            </el-table-column>
            <el-table-column label="标书款支付情况" min-width="160">
                <template slot-scope="scope">
                    <my-tag v-if="scope.row.payStatus==='已支付'" type="success"> {{scope.row.payStatus}}</my-tag>
                    <my-tag v-if="scope.row.payStatus==='未支付'" type="warning"> {{scope.row.payStatus}}</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="160">
                <template slot-scope="scope">
                    <my-btn type="detail" @click="shdetail(scope.row.guidcode,'1')">详情</my-btn>
                    <el-button type="text" v-if="scope.row.shbj==='1'" icon="el-icon-finished"  @click="sh(scope.row.guidcode)">审核</el-button>                     
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-if="$route.query.isXt!=='1'"  :after-query="firstData" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/Zbdl/AuditBmZl/get_list.json`"></my-pagination>
        <my-pagination ref="page" v-if="$route.query.isXt==='1'"  :after-query="firstData" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/Zbdl/AuditBmZl/xingtai/get_list.json`"></my-pagination>
        <my-dialog title="审核" v-model="dialogVisible">
            <formAudit @cancle="cancle" :rows="shrows" :back="back"></formAudit>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import formAudit from './sub-pages/form-audit'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                procode:this.getQuery('procode'),
                bdname:'',
                tbdwname:'',
                shbj:'1'
            },
            isreadshow:true,
            shrows:'',
            back:'',
            dialogVisible:false,
            bdlist:[],
            shlist:[
                {type:'',name:'全部'},
                {type:'1',name:'待审核'},
                {type:'3',name:'已退回'},
                {type:'9',name:'已通过'}
            ],
            loading:false
        }
    },
    components:{
        formAudit
    },
    methods:{ 
         firstData(table){
            var that = this
            table.forEach(function (item){
                if(item.guidcode!=null&&item.guidcode!=""){
                    $.get(`${that.getGetters('bidUrl')}/Zbdl/AuditBmZl/getpayinfo.json`, {
                        guidcode:item.guidcode,
                        t:Math.random(),
                    }, data => {
                       that.$set(item,'payStatus',data.msg)
                        // item.payStatus = data.msg 
                    });
                }
            })
            
        },
        exportexcel:function(){
            if(this.$route.query.isXt==='1'){
                console.log(1);
                console.log(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/xingtai/export?zbprocode=`+this.pgData.procode)
                window.location.href=`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/xingtai/export?zbprocode=`+this.pgData.procode;
            }else{
                console.log(2);
                console.log(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/export?zbprocode=`+this.pgData.procode)
                window.location.href=`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/export?zbprocode=`+this.pgData.procode;   
            }
        },
        cancle:function(data){
            if(data==='1'){
                this.reload();
                this.dialogVisible=false;
            }
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        sh:function(guidcode){
            this.back=1;
            this.shrows=guidcode;
            this.dialogVisible=true;
        },
        shdetail:function(guidcode,bssh){
            this.goto({
                path:'./detail',
                query:{
                    id:guidcode,
                    bssh:bssh,
                    isXt:this.$route.query.isXt
                }
            })
        },
        // 一键下载报名资料
        downloadBmzl(){
            var that = this
            that.loading = true;
            $.get(`${that.getGetters('bidUrl')}/Zbdl/AuditBmZl/downloadbmzl.json`, {
                procode:that.pgData.procode,
                bdname:that.pgData.bdname,
                tbdwname:that.pgData.tbdwname,
                shbj:that.pgData.shbj
            }, data => {
                if(data.code=='v'){
                    that.loading = false;
                    window.open(data.tdata)
                }else{
                    that.loading = false;
                    ShowMsg(data.msg, 'error');
                }
                
            });
        }
    },
    created(){
       
    },
    mounted(){
        if(this.$route.query.procode!=undefined){
            this.pgData.procode=this.$route.query.procode;
        }       
     
    }
}
</script>

<style>

</style>